export const parseStatusEtapa = (status: string) => {
    switch (status) {
        case "AGUARDANDO":
            return "Aguardando"
        case "ANDAMENTO":
            return "Em andamento"
        case "FINALIZADO":
            return "Finalizado"
        case "APROVADO":
            return "Aprovado"
        case "REPROVADO":
            return "Reprovado"

    }
}

export const parseSituacaoInscricao = (situacao: string) => {
    switch (situacao) {
        case "INSCRITO":
            return "Inscrito"
        case "APROVADO":
            return "Aprovado"
        case "REJEITADO":
            return "Rejeitado"
    }
}